import { render, staticRenderFns } from "./panel-link.vue?vue&type=template&id=ec4363ce"
import script from "./panel-link.vue?vue&type=script&lang=js"
export * from "./panel-link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports